import React, { useState, useEffect } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import { useStoreSettings } from "../../../hooks/useStoreSettings";
import { DEFAULT_STORE_ID } from "../../../firebase/firebase";
import { getFullHomePageContent } from "../../../firebase/settings-functions";
import "./AboutUsPage.css";
import img4 from "../../../assets/placeholder.png";

const AboutUsPage = () => {
  const { language } = useLanguage();
  const { storeSettings, loading } = useStoreSettings(DEFAULT_STORE_ID);
  const [homePageContent, setHomePageContent] = useState(null);
  const [contentLoading, setContentLoading] = useState(true);

  // Fetch home page content for About Us image
  useEffect(() => {
    const fetchHomePageContent = async () => {
      try {
        setContentLoading(true);
        const content = await getFullHomePageContent(DEFAULT_STORE_ID);
        setHomePageContent(content);
      } catch (err) {
        console.error("Error fetching home page content:", err);
      } finally {
        setContentLoading(false);
      }
    };

    fetchHomePageContent();
  }, []);

  // Translations for about us page
  const translations = {
    en: {
      aboutUs: "About us",
      aboutAlt: "About Us"
    },
    ar: {
      aboutUs: "معلومات عنا",
      aboutAlt: "معلومات عنا"
    }
  };

  const t = translations[language] || translations.en;

  if (loading || contentLoading) {
    return (
      <div className="contact-loading">
        <div className="loader"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Use custom About Us image if available, otherwise fall back to default
  const aboutUsImage = homePageContent?.aboutUsSection?.imageUrl || img4;

  return (
    <div className="aboutus-page-container">
      {/* Hero Image */}
      <div className="aboutus-hero-section">
        <img src={aboutUsImage} alt={t.aboutAlt} className="aboutus-hero-image" />
      </div>

      {/* About Content */}
      <div className="aboutus-content-section">
        <p className="aboutus-page-title">{t.aboutUs}</p>
        <p className="aboutus-description-text" dir={language === 'ar' ? 'rtl' : 'ltr'}>
          {storeSettings?.description}
        </p>
      </div>
    </div>
  );
};

export default AboutUsPage;
